export const SCREEN = "SCREEN";



export const screenAction = () => ({
  type: SCREEN,

});